import React from 'react';
import { WhatsAppLead } from '../../types/whatsapp';
import { SearchIcon, FilterIcon } from 'lucide-react';
import { ChannelBadge } from './ChannelBadge';
interface ConversationListProps {
  leads: WhatsAppLead[];
  selectedLeadId: number | null;
  onSelectLead: (lead: WhatsAppLead) => void;
}
export function ConversationList({
  leads,
  selectedLeadId,
  onSelectLead
}: ConversationListProps) {
  return <div className="flex flex-col h-full bg-white border-r border-gray-200 w-80" data-id="element-426">
      <div className="p-4 border-b border-gray-200" data-id="element-427">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-428">Inbox</h2>
        <div className="relative mb-3" data-id="element-429">
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-430" />
          <input type="text" placeholder="Search conversations..." className="w-full pl-9 pr-4 py-2 bg-gray-100 border-0 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 transition-all" data-id="element-431" />
        </div>
        <div className="flex space-x-2 overflow-x-auto pb-1 scrollbar-hide" data-id="element-432">
          <button className="px-3 py-1 bg-gray-900 text-white rounded-full text-xs font-medium whitespace-nowrap" data-id="element-433">
            All
          </button>
          <button className="px-3 py-1 bg-gray-100 text-gray-600 hover:bg-gray-200 rounded-full text-xs font-medium whitespace-nowrap" data-id="element-434">
            Unread
          </button>
          <button className="px-3 py-1 bg-gray-100 text-gray-600 hover:bg-gray-200 rounded-full text-xs font-medium whitespace-nowrap" data-id="element-435">
            High Priority
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto" data-id="element-436">
        {leads.map(lead => <div key={lead.id} onClick={() => onSelectLead(lead)} className={`p-4 border-b border-gray-100 cursor-pointer transition-colors hover:bg-gray-50 ${selectedLeadId === lead.id ? 'bg-blue-50 border-l-4 border-l-blue-600' : 'border-l-4 border-l-transparent'}`} data-id="element-437">
            <div className="flex justify-between items-start mb-1" data-id="element-438">
              <div className="flex items-center space-x-3" data-id="element-439">
                <div className="relative" data-id="element-440">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center text-blue-700 font-bold" data-id="element-441">
                    {lead.name.charAt(0)}
                  </div>
                  {lead.status === 'active' && <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full" data-id="element-442"></div>}
                </div>
                <div data-id="element-443">
                  <h3 className={`font-semibold text-sm ${selectedLeadId === lead.id ? 'text-blue-900' : 'text-gray-900'}`} data-id="element-444">
                    {lead.name}
                  </h3>
                  <div className="flex items-center space-x-1" data-id="element-445">
                    <span className="text-xs text-gray-500" data-id="element-446">
                      {lead.carModel}
                    </span>
                  </div>
                </div>
              </div>
              <span className="text-xs text-gray-400 whitespace-nowrap" data-id="element-447">
                {lead.lastMessageTime}
              </span>
            </div>

            <div className="pl-[52px]" data-id="element-448">
              <p className="text-sm text-gray-600 line-clamp-1 mb-2" data-id="element-449">
                {lead.lastMessage}
              </p>
              <div className="flex justify-between items-center" data-id="element-450">
                <div className="flex space-x-1" data-id="element-451">
                  <ChannelBadge channel="whatsapp" size="sm" data-id="element-452" />
                  {lead.aiScore > 80 && <ChannelBadge channel="auto-trigger" size="sm" data-id="element-453" />}
                </div>
                {lead.unreadCount > 0 && <span className="bg-green-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-454">
                    {lead.unreadCount}
                  </span>}
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}